module.exports = "/virtual-football-league/img/amblems/left/logos/Leicester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Leicester.png
// module id = 2103
// module chunks = 4